import { render, staticRenderFns } from "./Myculture.vue?vue&type=template&id=59b9ab44"
import script from "./Myculture.vue?vue&type=script&lang=js"
export * from "./Myculture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports